function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M28.5,9.8c0,0.3,0,0.5,0,0.8c0,8.3-6.3,17.8-17.8,17.8c-3.4,0-6.7-1-9.6-2.8c0.5,0.1,1,0.1,1.5,0.1c2.8,0,5.5-0.9,7.8-2.7 c-2.7-0.1-5-1.8-5.8-4.3c0.9,0.2,1.9,0.1,2.8-0.1c-2.9-0.6-5-3.2-5-6.1v-0.1c0.8,0.5,1.8,0.7,2.8,0.8C3.5,12,2.5,10,2.5,7.9 c0-1.1,0.3-2.2,0.8-3.1c3.2,3.9,7.9,6.3,12.9,6.5c-0.8-3.4,1.3-6.7,4.7-7.5c0.5-0.1,0.9-0.2,1.4-0.2c1.8,0,3.4,0.8,4.6,2 c1.4-0.3,2.7-0.8,4-1.5c-0.5,1.4-1.4,2.7-2.7,3.5c1.2-0.1,2.4-0.5,3.6-1C30.8,7.8,29.8,8.9,28.5,9.8z"
});

function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve"
  }, props), _ref);
}

export default SvgTwitter;